import SubscriptionsNewResponse from '@alltrails/core/types/SubscriptionsNewResponse';
import { get } from '@alltrails/core/utils/get';

export default async function getSubscriptionsNew() {
  return get<SubscriptionsNewResponse>(`/api/alltrails/purchases/subscriptions/new`);
}
